module.exports = __webpack_public_path__ + "img/16_34.b833b880.png";